import {
  useState,
  useImperativeHandle,
  useRef,
  useEffect,
  forwardRef,
  useCallback,
} from "react";
import { INDEX, ALERT_MESSAGES } from "../../constants";
import { getBase64FromFile } from "../../helpers";
import { FileRenderer } from "../customRenderers";
import { INTERFACES } from "../organisms/AppDrawers/drawers.constants";
import { actions } from "../../components/organisms/Alert/alert.reducers";
import { useDispatch } from "react-redux";

const { setAlert } = actions;
const { FIRST } = INDEX;
const { IMAGE } = INTERFACES;
const { EXTENSION_NOT_SUPPORTED } = ALERT_MESSAGES

const FileEditor = (field) =>
  forwardRef(function FileEditor(props, ref) {
    const { value, api } = props;
    const [selectedFile, setSelectedFile] = useState(
      value || field.schema.defaultValue
    );
    const [shouldCloseEditor, setShouldCloseEditor] = useState(false);
    const refInput = useRef(null);
    const dispatch = useDispatch();

    // afterGuiAttached
    useEffect(() => {
      refInput.current.click();
      return () => dispatch(setAlert());
    }, [dispatch]);

    useEffect(() => {
      if (shouldCloseEditor) api.stopEditing();
    }, [shouldCloseEditor, api]);

    useImperativeHandle(ref, () => {
      return {
        // the final value to send to the grid, on completion of editing
        getValue() {
          return selectedFile;
        },
      };
    });

    const onChangeListener = useCallback(
      async (event) => {
        const file = event.target.files[FIRST];
        const fileExtension = file?.name.split(".").pop();

        const isInvalidImageType =
          field.meta.interface === IMAGE &&
          fileExtension &&
          !field.meta.selectedChoices.includes(`.${fileExtension},`);

        if (isInvalidImageType)
          dispatch(setAlert({ message: EXTENSION_NOT_SUPPORTED }));
        else {
          const base64Url = await getBase64FromFile(file);
          setSelectedFile(JSON.stringify({ name: file.name, base64Url }));
          setShouldCloseEditor(true);
        }
      },
      [dispatch]
    );

    return (
      <div className="px-4 h-full">
        <label htmlFor="fileInput">
          {FileRenderer({ ...props, value: selectedFile }, field)}
        </label>
        <input
          type="file"
          id="fileInput"
          ref={refInput}
          className="hidden"
          onChange={onChangeListener}
          {...(field.meta.interface === IMAGE && {
            accept: field.meta.selectedChoices,
          })}
        />
      </div>
    );
  });
export default FileEditor;
